import m, { useState as f, useEffect as v } from "react";
import h from "classnames";
import { KioskConfigurationHomeMode as k } from "../../../../../features/api/models/kiosk/configuration/kioskConfigurationHome/kioskConfigurationHome.model.js";
import { useKioskLanding as g } from "../../context.js";
import s from "./home.module.scss.js";
import { useKioskSchedule as I } from "../../hooks/useKioskSchedule.js";
function N() {
  const { configuration: e, goTo: r } = g(), { scheduleCompliance: c } = I(), [l, a] = f(0), o = (e == null ? void 0 : e.home.design.images.background) ?? [], d = (e == null ? void 0 : e.home.settings.sliderSpeed) ?? 1, i = (e == null ? void 0 : e.home.settings.mode) !== k.TOTEM;
  function u() {
    a((t) => t + 1 >= o.length ? 0 : t + 1);
  }
  v(() => {
    const t = setInterval(() => {
      u();
    }, d * 1e3);
    return () => {
      clearInterval(t);
    };
  }, []);
  function p() {
    if (i) {
      if (!c.complies) {
        r("out-of-order");
        return;
      }
      r("service");
    }
  }
  return /* @__PURE__ */ m.createElement(
    "div",
    {
      "data-testid": "home",
      className: s.wrapper,
      onClick: () => p(),
      style: {
        cursor: i ? "pointer" : void 0
      }
    },
    o.map((t, n) => /* @__PURE__ */ m.createElement(
      "img",
      {
        className: h({
          [s.image]: !0,
          [s.active]: n === l
        }),
        key: n,
        alt: "slide",
        src: t
      }
    ))
  );
}
export {
  N as Home
};
//# sourceMappingURL=Home.js.map
